import React, { useEffect } from 'react';
import { CustomerJourneyProvider, useCustomerJourney } from '../context/setup';
import CustomerJourneyStepper from './CustomerJourneyStepper';
import { useAuth } from '@/contexts';
import { ActionType, PlanType } from '../context/types';
import { useIntercom } from '@/hooks/useIntercom';
import { useWindowResize } from '@/hooks';

const CustomerJourneySetup: React.FC = () => {
  return (
    <CustomerJourneyProvider>
      <SetupContent />
    </CustomerJourneyProvider>
  );
};

const SetupContent: React.FC = () => {
  const { dispatch } = useCustomerJourney();
  const { session } = useAuth();
  const { isMobileSize } = useWindowResize();

  // Conditionally call useIntercom based on DOM readiness
  useIntercom(!isMobileSize && typeof window !== 'undefined');

  const isVenue = session?.is_venue;

  useEffect(() => {
    if (session) {
      dispatch({
        type: ActionType.SET_PLAN,
        payload: isVenue ? PlanType.BUSINESS : PlanType.PRO
      });
      if (isVenue) {
        dispatch({
          type: ActionType.SET_PLAN_PROFESSIONALS_COUNT,
          payload: session.vendor?.venue?.staff_count === 1 ? 2 : session.vendor?.venue?.staff_count || 2
        });
      }
    }
  }, [session, dispatch, isVenue]);

  return (
    <main className="max-w-3xl mx-auto p-2 sm:p-4 flex items-center justify-center min-h-[calc(100dvh-4rem)]">
      <CustomerJourneyStepper />
    </main>
  );
};

export default CustomerJourneySetup;
